// src/utils/distance.js

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
  
    const R = 6371; // Earth's radius in km
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance; // in km
  };
  
export const getMaxServiceableDistance = (serviceableLocation) => {
  switch (serviceableLocation) {
    case 'within_10kms': return 10;
    case 'within_50kms': return 50;
    case 'within_100kms': return 100;
    case 'within_1000kms': return 1000;
    case 'more_than_1000kms': return Infinity;
    default: return 0;
  }
};